import { useCompanyValues } from '@/providers';
import { FC } from 'react';
import { BaseLanding } from './BaseLanding';
import { ExternalLanding } from './ExternalLanding';

export const Landing: FC = () => {
  const { isDefault } = useCompanyValues();

  return <>{isDefault ? <BaseLanding /> : <ExternalLanding />}</>;
};
